// src/hooks/useDesktopPlatforms.js
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// The platforms a tool can ship an installer for, straight from
// backend/src/config/desktop.js — the same list the upload validator uses, so
// the admin form can't offer a file type the server will reject. Like the
// categories, it only changes when that config does.
export const useDesktopPlatforms = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['desktop-platforms'],
    queryFn: async () => {
      const response = await api.get('/tools/desktop/platforms');
      return response.data;
    },
    staleTime: Infinity,
  });

  return {
    platforms: data?.platforms || [],
    maxUploadBytes: data?.maxUploadBytes || 0,
    isLoading,
  };
};
